import { createFileRoute } from '@tanstack/react-router'
import EmployeeProfile from '@/features/employee-portal/pages/EmployeeProfile'

export const Route = createFileRoute('/_authenticated/employee-portal/profile')({
  component: EmployeeProfile,
})